module.exports = __webpack_public_path__ + "img/front.e4361838.png";